import { CITY } from '@lts-web/types/LocationTypes';
import { ORIGIN_ALL } from '@lts-web/utils/LocationUtil';
import { UNKNOWN } from "@lts-web/types/DefaultDateTypes";

/**
 * Dates DataSet
 *
 * @param departDate
 * @param returnDate
 * @param dateType
 * @param routeType
 *
 * @returns {Object}
 */

export const dates = (departDate, returnDate, dateType, routeType) => ({
    departDate: departDate || '',
    returnDate: returnDate || '',
    oneWayDepartDate: departDate || '',
    multiDepartDate: departDate  || '',
    flightReturnDate: returnDate  || '',
    dateType: dateType || UNKNOWN,
    routeType: routeType || '2'
});

/**
 * Passengers DataSet
 *
 * @param adultsNum
 * @param childrenNum
 * @param babyNum
 *
 * @returns {Object}
 */
export const passengers = (adultsNum, childrenNum, babyNum) => ({
    adultsNum: parseInt(adultsNum || 1),
    childrenNum: parseInt(childrenNum || 0),
    babyNum: parseInt(babyNum || 0)
});

/**
 * Pax/Roomlist Dataset
 *
 * @param roomNum
 * @param room0adults
 * @param room0children
 * @param room0childAge
 * @param room0infants
 * @param room1adults
 * @param room1children
 * @param room1childAge
 * @param room1infants
 * @param room2adults
 * @param room2children
 * @param room2childAge
 * @param room2infants
 *
 *
 * @returns {{room2children: (*|number), room2adults: (*|number), roomNum: number, room0childAge: (*|*[]), room1adults: (*|number), room1children: (*|number), room1childAge: (*|*[]), room0children: (*|number), room0adults: (*|number), room2childAge: (*|*[]),room0baby: (*|number),room1baby: (*|number),room2baby: (*|number)}}
 */
export const pax = (
    roomNum,
    room0adults,
    room0children,
    room0childAge,
    room0infants,
    room1adults,
    room1children,
    room1childAge,
    room1infants,
    room2adults,
    room2children,
    room2childAge,
    room2infants
) => ({
    roomNum: parseInt(roomNum || 1),
    room0adults: room0adults || 2,
    room0children: room0children || 0,
    room0childAge: room0childAge || [],
    room0infants: room0infants || 0,
    room1adults: room1adults || 2,
    room1children: room1children || 0,
    room1childAge: room1childAge || [],
    room1infants: room1infants || 0,
    room2adults: room2adults || 2,
    room2children: room2children || 0,
    room2childAge: room2childAge || [],
    room2infants: room2infants || 0
});

/**
 * Budget DataSet
 *
 * @param currency
 * @param from
 * @param changed
 *
 * @returns {Object}
 */
export const budget = (currency, from, changed) => ({
    budgetFrom: from || 0,
    budgetChanged: changed === true,
    currency: currency || 'USD'
});

/**
 * Locations DataSet
 *
 * @param departure
 * @param destination
 * @param returnFromAirport
 * @param locationType
 *
 * @returns {Object}
 */
export const locations = (departure, destination, returnFromAirport, locationType) => ({
    departure: departure || ORIGIN_ALL,
    destination: destination || '',
    returnToAirport: departure || ORIGIN_ALL,
    returnFrom: destination || '',
    returnFromAirport: returnFromAirport || '',
    oneWayDepartFrom: departure || ORIGIN_ALL,
    oneWayDepartTo: destination || '',
    multiDepartFrom: departure || ORIGIN_ALL,
    locationType: locationType || CITY
});

export const hotel = (hotelCode) => {
    return {
        hotelCode: hotelCode || ''
    };
};

/**
 * Subject DataSet
 * @param subject
 * @returns {Object}
 */
export const subject = (subject) => {
    return {
        subject: subject || ''
    };
};

/**
 * Filters DataSet
 *
 * @param broad
 * @param hotelName
 * @param range
 * @param city
 * @param month
 * @param nightsAmount
 * @param carType
 * @param carCategory
 *
 * @returns {Object}
 */
export const filters = (broad, hotelName, range, city, month, nightsAmount, carType, carCategory) => ({
    sortTypeByBroad: broad || 'RO',
    sortTypeByHotelName: hotelName || '',
    sortTypeByRange: range || '',
    sortTypeByCity: city || '',
    sortTypeByMonth: month || '',
    sortTypeByNightsAmount: nightsAmount || '',
    sortTypeByCarType: carType || '',
    sortTypeByCarCategory: carCategory
});

/**
 * Options DataSet
 *
 * @param domesticDiscountType
 * @param useDomesticVoucher
 * @param matrixSearch
 * @param fromAbroadFlight
 * @param allowAllDomesticAirportsResponse
 *
 * @return {Object}
 */
export const options = (
    domesticDiscountType = 0,
    useDomesticVoucher = false,
    matrixSearch = false,
    fromAbroadFlight = false,
    allowAllDomesticAirportsResponse = false
) => {
    return {
        domesticDiscountType,
        useDomesticVoucher,
        matrixSearch,
        fromAbroadFlight,
        allowAllDomesticAirportsResponse
    }
};

/**
 * Message DataSet
 *
 * @param code
 * @param dataSet
 * @param description
 * @param text {Function}
 *
 * @returns {Object}
 */
export const message = (code, dataSet, description, text = ()=>'') => ({
    msgCode: code,
    msgDesc: description,
    msgText: typeof text !== 'function' ? () => text : text,
    msgDataSet: dataSet
});